import React from "react";
import { MapComponent, MapTypes } from "@neshan-maps-platform/mapbox-gl-react";
import "@neshan-maps-platform/mapbox-gl/dist/NeshanMapboxGl.css";
export default function MapTestPage() {
  return (
    <div
      style={{
        height: 400,
        width: 400,
        position: "relative",
      }}
    >
      <style>
        {`
                .mapboxgl-map {
                overflow:visible !IMPORTANT;
                }
                .mapboxgl-canvas {
                height:400px;
                width: 400px;
                }
                `}
      </style>
      <MapComponent
        options={{
          mapKey: "web.1d5f93475eea4ab18d8eedcbe3f8cb80",
          mapType: MapTypes.neshanRaster,
        }}
      />
    </div>
  );
}
